import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';

import { useBoxBuilderStore } from '@/store/box/boxBuilder';
import { useAssessmentResultStore } from '@/store/assessment/assessmentResult';

import useBlockComposable from '@/composables/BlockComposable';
import useFormulaComposable from '@/composables/FormulaComposable';

import { SharedTypes } from '../enums';

const useBoxBuilderComposable = () => {
    const store = useStore();
    const company_id = computed(() => {
        return store.getters['auth/userCompanyId']?.id;
    });

    const { blocks, getAllBlocks } = useBlockComposable();
    const { formulas, fetchFormulas } = useFormulaComposable();
    const { selectedBlockId } = storeToRefs(useBoxBuilderStore());
    const { setSelectedBlockId } = useBoxBuilderStore();
    const { fonts, parentTemplates } = storeToRefs(useAssessmentResultStore());
    const { getAllFonts, getAllTemplatesLinkedToBlock, addResultTemplate, deleteResultTemplate } = useAssessmentResultStore();

    onMounted(async () => {
        await getAllBlocks(SharedTypes.COMPANY, {});
        await fetchFormulas(SharedTypes.COMPANY);
    });

    const submitResultTemplate = async (resultTemplateBody) => {
        return await addResultTemplate(selectedBlockId.value, { ...resultTemplateBody, company_id: company_id.value });
    };

    const removeResultTemplate = async (template_id) => {
        await deleteResultTemplate(selectedBlockId.value, template_id, company_id.value);
    };

    const setBlockId = async (block_id) => {
        setSelectedBlockId(block_id);
        await getAllTemplatesLinkedToBlock(block_id, company_id.value);
    };

    return {
        blocks,
        formulas,
        fonts,
        parentTemplates,
        selectedBlockId,
        setBlockId,
        submitResultTemplate,
        removeResultTemplate,
        getAllFonts,
    };
};

export default useBoxBuilderComposable;
